function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M469.988,75c0-1.302-0.242-2.609-0.757-3.846l-25-60C442.678,7.427,439.037,5,435,5s-7.678,2.427-9.23,6.154l-25,60 c-0.516,1.237-0.757,2.544-0.757,3.846H400v340v40c0,5.523,4.478,10,10,10h50c5.522,0,10-4.477,10-10v-40V75H469.988z M435,41 l10,24h-20L435,41z M450,445h-30v-20h30V445z M450,405h-30V85h30V405z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370,0H35c-5.523,0-10,4.477-10,10v30H10C4.477,40,0,44.477,0,50v410c0,5.523,4.477,10,10,10h320c5.522,0,10-4.477,10-10 v-30h30c5.522,0,10-4.477,10-10V10C380,4.477,375.522,0,370,0z M320,450H20V60h300V450z M360,410h-20V50c0-5.523-4.478-10-10-10 H45V20h315V410z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 80,
  width: 65,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 120,
  width: 65,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 95,
  y: 180,
  width: 205,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 220,
  width: 260,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 260,
  width: 260,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 300,
  width: 260,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 340,
  width: 260,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 380,
  width: 215,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  x: 270,
  y: 380,
  width: 30,
  height: 20
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgContracts = function SvgContracts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470 470",
    style: {
      enableBackground: "new 0 0 470 470"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContracts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contracts.a160c643.svg";
export { ForwardRef as ReactComponent };